import { Link } from "react-router-dom";

// Admin moderation views: participant name → their public profile (navigation only).
export function ProfileNameLink({ user, children, testId }) {
  if (!user?.id) return <>{children}</>;
  return (
    <Link
      to={`/profile/${user.id}`}
      className="inline-flex items-center min-h-[28px] underline decoration-dotted underline-offset-2 hover:decoration-solid hover:text-[hsl(var(--sb-forest-2))] rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
      title="Open public profile"
      data-testid={testId || `admin-profile-link-${user.id}`}
    >
      {children}
    </Link>
  );
}
